// Pure rules behind the kitchen-basics screen (Stage 2D). Tested in basicsLogic.test.ts.
import type { KitchenBasic } from './basicsTypes'

export const canAskBasics = (role: string) => role === 'admin' || role === 'kitchen_manager'
export const canPushBasics = (role: string) => role === 'admin' || role === 'inventory_manager'

/** The amounts to send, pre-filled with each top-up (running low only). */
export function initialSends(rows: KitchenBasic[]): Record<string, number> {
  return Object.fromEntries(rows.filter((r) => r.top_up > 0).map((r) => [r.stock_item_id, r.top_up]))
}

export function sendLines(sends: Record<string, number>): { stock_item_id: string; qty: number }[] {
  return Object.entries(sends).filter(([, q]) => q > 1e-6).map(([stock_item_id, qty]) => ({ stock_item_id, qty }))
}

/** Push: the store cannot send more than it holds (a warning, not a block). */
export function overStore(rows: KitchenBasic[], sends: Record<string, number>): string[] {
  return rows.filter((r) => (sends[r.stock_item_id] ?? 0) > r.store_on_hand + 1e-9).map((r) => r.name)
}

/**
 * The amounts after the list refetches (pilot fix, Batch 5 lane tablet): an
 * amount the person changed is kept; the others follow the new top-ups; items
 * no longer on the list drop out. A refetch used to wipe every edit.
 */
export function mergeSends(rows: KitchenBasic[], prev: Record<string, number>, edited: ReadonlySet<string>): Record<string, number> {
  const out: Record<string, number> = {}
  for (const r of rows) {
    if (edited.has(r.stock_item_id) && r.stock_item_id in prev) out[r.stock_item_id] = prev[r.stock_item_id]
    else if (r.top_up > 0) out[r.stock_item_id] = r.top_up
  }
  return out
}
